import React, { useEffect, useState } from "react";

import {
  LoginSocialGoogle,
  LoginSocialFacebook,
  LoginSocialLinkedin,
  LoginSocialMicrosoft,
  LoginSocialApple,
  IResolveParams,
} from 'reactjs-social-login';
import { FaGoogle, FaMicrosoft, } from "react-icons/fa";
import { Grid, Icon, IconButton, Stack } from "@mui/material";

import { GOOGLE_CLIENT_ID, MICROSOFT_CLIENT_ID, LOGIN_REDIRECT_URI } from '../../../common/constants';
import { rgba } from '../../../common/functions';

const Social = ({ handleSso }) => {
  

  return (
    <Grid container spacing={2} justifyContent="center" alignItems="center">
      <Grid item>
        <Stack mb="25px" justifyContent="center" alignItems="center" direction="row" spacing={2}>
          <LoginSocialGoogle
            scope="profile email"
            client_id={GOOGLE_CLIENT_ID}
            //typeResponse="idToken"
            //ux_mode="popup"
            redirect_uri={LOGIN_REDIRECT_URI}
            isOnlyGetToken
            onLoginStart={() => {
              console.log('onLoginStart, google')
            }} // onLoginStart
            onResolve={async ({ provider, data }) => {
              //setProvider(provider);
              //setProfile(data);
              console.log({ provider, data });
              handleSso({ provider, data });
            }}
            onReject={err => {
              console.log(err);
            }}
          >
            <IconButton
              transition="all .25s ease"
              justify="center"
              align="center"
              bg="rgb(19,21,54)"
              borderRadius="15px"
            >
              <Icon
                as={FaGoogle}
                w="30px"
                h="30px"
              />
            </IconButton>
          </LoginSocialGoogle>
      

      
          <LoginSocialMicrosoft
            isOnlyGetToken
            scope="openid profile email user.read"
            client_id={MICROSOFT_CLIENT_ID}
            redirect_uri={LOGIN_REDIRECT_URI}
            onLoginStart={() => { console.log('onLoginStart, microsoft') }}
            onResolve={({ provider, data }) => {
              console.log({ provider, data });
            }}
            onReject={(err) => {
              console.log(err)
            }}
          >
            <IconButton
              transition="all .25s ease"
              justify="center"
              align="center"
              bg="rgb(19,21,54)"
              borderRadius="15px"
            >
              <Icon
                as={FaMicrosoft}
                w="30px"
                h="30px"
              />
            </IconButton>
          </LoginSocialMicrosoft>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default Social;
